import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from './Header';
import Menu from './CommonMenu';
import GiangSuPageApi from './GiangSuPageApi';
import HomePageApi from './HomePageApi';
import { LINK_YOUTUBE_IMAGE } from './Constants';
import $ from 'jquery';

// Tab hiển thị -> tham số sort của API
const SORT_BY_TAB = {
  MoiNhat: 'new',
  XemNhieu: 'view',
  TaiNhieu: 'download',
};

function GiangSuDetailPage() {
  const [searchParams] = useSearchParams();
  const postId = searchParams.get('postId');
  const [dataChiTiet, setDataChiTiet] = useState(null);
  const [loading, setLoading] = useState(true);
  const [giangSuList, setGiangSuList] = useState([]);

  const [audioTab, setAudioTab] = useState('MoiNhat');
  const [audioData, setAudioData] = useState([]);
  const [audioPage, setAudioPage] = useState(1);
  const [audioTotalPages, setAudioTotalPages] = useState(1);

  const [videoTab, setVideoTab] = useState('MoiNhat');
  const [videoData, setVideoData] = useState([]);
  const [videoPage, setVideoPage] = useState(1);
  const [videoTotalPages, setVideoTotalPages] = useState(1);

  const getVideoID = (url) => {
    if (!url) return null;
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/\n\s]+\/|(?:v|e(?:mbed|d)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  const loadAudio = (tab, page) => {
    GiangSuPageApi.getAudioByGiangSu(postId, page, SORT_BY_TAB[tab]).then((res) => {
      if (!res) return;
      setAudioData(res.data || []);
      setAudioTotalPages(res.totalPages || 1);
    });
  };

  const loadVideo = (tab, page) => {
    GiangSuPageApi.getVideoByGiangSu(postId, page, SORT_BY_TAB[tab]).then((res) => {
      if (!res) return;
      const list = res.data || [];
      list.forEach((item) => {
        const videoId = getVideoID(item.value);
        item.imageUrl = videoId ? LINK_YOUTUBE_IMAGE.replace('{videoId}', videoId) : '';
      });
      setVideoData(list);
      setVideoTotalPages(res.totalPages || 1);
    });
  };

  const handleAudioTabClick = (tab) => {
    setAudioTab(tab);
    setAudioPage(1);
    loadAudio(tab, 1);
  };

  const handleAudioPageClick = (page) => {
    setAudioPage(page);
    loadAudio(audioTab, page);
  };

  const handleVideoTabClick = (tab) => {
    setVideoTab(tab);
    setVideoPage(1);
    loadVideo(tab, 1);
  };

  const handleVideoPageClick = (page) => {
    setVideoPage(page);
    loadVideo(videoTab, page);
  };

  useEffect(() => {
    $('.tlt').textillate({
      loop: true,
      minDisplayTime: 20000,
      in: {
        effect: 'fadeIn',
        delayScale: 3,
        shuffle: false,
      },
      out: {
        effect: 'fadeOut',
        delayScale: 1.5,
        delay: 100,
        sync: false,
        shuffle: false,
        reverse: false,
      }
    });

    $("#sky-bg").fadeIn(2e3);

    HomePageApi.getDataGiangSu().then((data) => setGiangSuList(data || [])).catch(console.error);
  }, []);

  useEffect(() => {
    if (!postId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    GiangSuPageApi.getChiTietGiangSuAdmin(postId, 26)
      .then((res) => {
        const detail = Array.isArray(res) && res.length > 0 ? res[0] : (res && res.data && res.data[0]) || null;
        if (detail) {
          const dateStr = detail.date_create || detail.Date_Create;
          if (dateStr) {
            const date = new Date(dateStr);
            detail.formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
          }
          setDataChiTiet(detail);
        } else {
          setDataChiTiet(null);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });

    // Reset về tab đầu khi đổi giảng sư
    setAudioTab('MoiNhat');
    setAudioPage(1);
    setVideoTab('MoiNhat');
    setVideoPage(1);
    loadAudio('MoiNhat', 1);
    loadVideo('MoiNhat', 1);
  }, [postId]);

  // Phân trang dùng chung cho cả audio và video
  const Pagination = ({ currentPage, totalPages, onPageClick }) => (
    <div className="row">
      <div className="col-md-12 col-sm-12 col-xs-12">
        <div className="pagination-container">
          <ul className="pagination">
            {currentPage > 1 && (
              <li className="PagedList-skipToLast">
                <a onClick={() => onPageClick(1)}>««</a>
              </li>
            )}
            {currentPage > 1 && (
              <li className="PagedList-skipToNext">
                <a onClick={() => onPageClick(currentPage - 1)} rel="prev">«</a>
              </li>
            )}

            {[...Array(totalPages)].map((_, index) => {
              const page = index + 1;
              const startPage = Math.max(1, currentPage - 3);
              const endPage = Math.min(totalPages, currentPage + 8);

              if (page >= startPage && page <= endPage) {
                return (
                  <li key={page} className={currentPage === page ? 'active' : ''}>
                    <a onClick={() => onPageClick(page)}>{page}</a>
                  </li>
                );
              }
              return null;
            })}

            {currentPage < totalPages && (
              <li className="PagedList-skipToNext">
                <a onClick={() => onPageClick(currentPage + 1)} rel="next">»</a>
              </li>
            )}
            {currentPage < totalPages && (
              <li className="PagedList-skipToLast">
                <a onClick={() => onPageClick(totalPages)}>»»</a>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );

  const TabNav = ({ activeTab, onTabClick, xemNhieuLabel }) => (
    <nav className="tab-nav nav nav-tabs">
      <li
        style={{ backgroundColor: activeTab === 'MoiNhat' ? 'rgb(255,219,74)' : 'transparent' }}
        onClick={() => onTabClick('MoiNhat')}
      >
        <a className="btnTab" title="Mới nhất">
          <i className="fa fa-upload" /> MỚI NHẤT
        </a>
      </li>
      <li
        style={{ backgroundColor: activeTab === 'XemNhieu' ? 'rgb(255,219,74)' : 'transparent' }}
        onClick={() => onTabClick('XemNhieu')}
      >
        <a className="btnTab" title={xemNhieuLabel}>
          <i className="fa fa-eye" /> {xemNhieuLabel}
        </a>
      </li>
      <li
        style={{ backgroundColor: activeTab === 'TaiNhieu' ? 'rgb(255,219,74)' : 'transparent' }}
        onClick={() => onTabClick('TaiNhieu')}
      >
        <a className="btnTab" title="Tải nhiều">
          <i className="fa fa-download" /> TẢI NHIỀU
        </a>
      </li>
    </nav>
  );

  return (
    <div>
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <meta httpEquiv="Content-Language" content="vi" />
      <title>{dataChiTiet?.title || "Chi Tiết Giảng Sư"} | Linh Quy Pháp Ấn</title>
      <link rel="shortcut icon" href="/Upload/images/tab/logochuan.jpg" type="image/png" />

      <div className="fly-text">
        <ul>
          <li className="tlt">Nguyện thành tựu</li>
          <li className="tlt">Lòng tin bất động</li>
          <li className="tlt">Nơi Đức Phật, Chánh Pháp</li>
          <li className="tlt">Chúng Tăng và Thánh Giới</li>
          <li className="tlt" />
        </ul>
      </div>
      <div id="sky-bg">
        <div className="clouds_one" />
        <div className="clouds_two" />
        <div className="clouds_three" />
      </div>
      <Header />
      <section>
        <div className="container contentContainer">
          <div className="row">
            <div className="col-md-9 col-sm-9 col-xs-12">
              <Menu value={"home"} />

              {loading ? (
                <div style={{ padding: '50px 0', textAlign: 'center' }}>Đang tải...</div>
              ) : dataChiTiet ? (
                <div className="row" style={{ marginTop: '20px' }}>
                  <div className="col-md-12 col-sm-12 col-xs-12">
                    <div className="chiTietVideoAudio">
                      <div className="row">
                        <div className="col-md-12">
                          <h1 style={{ color: '#80271A', fontSize: '24px', fontWeight: 'bold', borderBottom: '2px solid #FFD21D', paddingBottom: '10px' }}>
                            {dataChiTiet.title}
                          </h1>
                          {dataChiTiet.description && (
                            <div style={{ background: '#fafafa', borderLeft: '4px solid #FFD21D', padding: '10px 15px', margin: '15px 0', fontStyle: 'italic' }}>
                              {dataChiTiet.description}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {dataChiTiet.content && (
                      <div className="rich-content" style={{ marginTop: '15px', lineHeight: '1.6', fontSize: '15px' }} dangerouslySetInnerHTML={{ __html: dataChiTiet.content }} />
                    )}

                    {/* ---------------- AUDIO CỦA GIẢNG SƯ ---------------- */}
                    <h5 className="tittleHome" style={{ marginTop: '25px' }}>Audio</h5>
                    <div className="col-md-12 col-sm-12 col-xs-12 tabVideoAudio hash-tabs" style={{ padding: 0 }}>
                      <article className="tab-container">
                        <TabNav activeTab={audioTab} onTabClick={handleAudioTabClick} xemNhieuLabel="NGHE NHIỀU" />
                        <div className="tab-pane-container">
                          <section className="homeListVideoUpdate audio" role="tabpanel" style={{ display: 'block' }}>
                            {audioData.length === 0 ? (
                              <div style={{ padding: '20px 0', color: '#666' }}>Chưa có audio nào của giảng sư này.</div>
                            ) : (
                              <>
                                <table className="table table-striped listAudio ">
                                  <tbody>
                                    {audioData.map((item, index) => (
                                      <tr key={item.id}>
                                        <td>
                                          <span>{((audioPage - 1) * 8) + index + 1}</span>
                                        </td>
                                        <td>
                                          <a className="ten-audio" href={`/audio/${item?.Slug_Full || ''}?id=${item?.id}`}>
                                            {item.title}
                                          </a>
                                          <span className="nguoi-giang">
                                            {item.value}
                                          </span>
                                        </td>
                                        <td> {item.Description} </td>
                                        <td className="lefticonListAudio">
                                          <a className="fa fa-headphones " href={`/audio/${item?.Slug_Full || ''}?id=${item?.id}`} />&nbsp;
                                          <a className="fa fa-plus-square   iconDonwload2 btnAddFav" data-id={item.id} data-type="audio" data-title={item.title} />
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                                <Pagination currentPage={audioPage} totalPages={audioTotalPages} onPageClick={handleAudioPageClick} />
                              </>
                            )}
                          </section>
                        </div>
                      </article>
                    </div>

                    {/* ---------------- VIDEO CỦA GIẢNG SƯ ---------------- */}
                    <h5 className="tittleHome" style={{ marginTop: '25px' }}>Video</h5>
                    <div className="col-md-12 col-sm-12 col-xs-12 tabVideoAudio hash-tabs" style={{ padding: 0 }}>
                      <article className="tab-container">
                        <TabNav activeTab={videoTab} onTabClick={handleVideoTabClick} xemNhieuLabel="XEM NHIỀU" />
                        <div className="tab-pane-container">
                          <section className="homeListVideoUpdate" role="tabpanel" style={{ display: 'block' }}>
                            {videoData.length === 0 ? (
                              <div style={{ padding: '20px 0', color: '#666' }}>Chưa có video nào của giảng sư này.</div>
                            ) : (
                              <>
                                <div className="row">
                                  {videoData.map((item, index) => (
                                    <div className="col-md-3 col-sm-6 col-xs-6 itemHomeListVideo itemListVideoTab" key={item.id || index}>
                                      <div className="containerOverlay">
                                        <img className="thumbHover lazy" alt="" title={item.title} src={item.imageUrl} />
                                        <div className="overlay">
                                          <a className="videoHover1" href={`/video/${item.Slug_Full || ''}?id=${item.id}`} alt="Xem"> <i className="fa fa-eye " /> Xem</a>
                                          <a className=" videoHover2  iconDonwload2 btnAddFav" data-id={item.id} data-type="video" data-title={item.title}><i className="fa fa-plus-square" /> Thêm</a>
                                          <a className="iconDonwload2 videoHover3 fancybox fancybox.ajax" href="javascript:;" data-fancybox-href={`/Widget/YoutubeDownload/${item.id}?videourl=${encodeURIComponent(item.value || '')}`}>
                                            <i className="fa fa-download" /> Tải
                                          </a>
                                        </div>
                                      </div>
                                      <div className="listVideoTitle2">
                                        <a className="Title" href={`/video/${item.Slug_Full || ''}?id=${item.id}`}>
                                          {item.title}
                                        </a>
                                        <p>
                                        </p>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                                <Pagination currentPage={videoPage} totalPages={videoTotalPages} onPageClick={handleVideoPageClick} />
                              </>
                            )}
                          </section>
                        </div>
                      </article>
                    </div>
                  </div>
                </div>
              ) : (
                <div style={{ padding: '50px 0', textAlign: 'center' }}>Không tìm thấy dữ liệu.</div>
              )}
            </div>

            {/* Sidebar */}
            <div className="col-md-3 col-sm-3 col-xs-12">
              <div className="boxNews" style={{ marginTop: '20px' }}>
                <div className="containerRightBox">
                  <h5 className="titleRightHome">DANH SÁCH CÁC GIẢNG SƯ</h5>
                  <ul className="nav nav-pills nav-stacked listDanhMuc" style={{ padding: '10px 0' }}>
                    {giangSuList.map((gs) => (
                      <li key={gs.Id} className={String(gs.Id) === String(postId) ? 'active' : ''}>
                        <a href={`/giang-su-chi-tiet?postId=${gs.Id}`}>
                          <i className="fa fa-angle-right fa-fw" /> {gs.Title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="boxNews" style={{ marginTop: '20px' }}>
                <div className="containerRightBox">
                  <h5 className="titleRightHome">LIÊN KẾT</h5>
                  <ul className="nav nav-pills nav-stacked listDanhMuc" style={{ padding: '10px 0' }}>
                    <li>
                      <a href="https://www.facebook.com/LINH-QUY-PH%C3%81P-%E1%BA%A4N-260666811038785/" target="_blank" rel="noreferrer">
                        <i className="fa fa-facebook fa-fw" /> Facebook
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/channel/UCnI54Nrr9AddC4pDdpIjyCg" target="_blank" rel="noreferrer">
                        <i className="fa fa-youtube fa-fw" /> YouTube
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}

export default GiangSuDetailPage;
